// extracted by mini-css-extract-plugin
export default {"mainPhoneNumber":"Phone-number_mainPhoneNumber__XKwji","PhoneTimer":"Phone-number_PhoneTimer__BEsOl"};